import { getLocales } from 'assets/locales/Locale';
import { ExpressionTypes } from 'models/enums/Automation';
import { AutomationOption, AutomationRuleSchema, createAssignEffect } from 'module/automation/helpers/AutomationTypes';

export const ClaimAutomationPropertyPath = {
  totalAmount: 'ClaimJob.TotalAmountCAD',
  claimStatus: 'ClaimJob.Claim.StatusCode',
  claimJobStatus: 'ClaimJob.StatusCode',
  //
  contractExpiryDate: 'ClaimJob.Claim.Contract.ExpiryDate',
  contractEffectiveDate: 'ClaimJob.Claim.Contract.EffectiveDate',
  contractSalePriceCAD: 'ClaimJob.Claim.Contract.SalePriceCAD',
};

type ClaimAutomationSchemaArgs = {
  claimStatuses: AutomationOption[];
  claimJobStatuses: AutomationOption[];
};

export function createClaimAutomationSchema({
  claimStatuses,
  claimJobStatuses,
}: ClaimAutomationSchemaArgs): AutomationRuleSchema {
  const { lang } = getLocales();
  const claimExpressionTypes = Object.values(ExpressionTypes);
  const claimDateExpressionTypes = claimExpressionTypes.filter((type) => type !== ExpressionTypes.Range);

  return {
    expressionProperties: [
      ClaimAutomationPropertyPath.totalAmount,
      ClaimAutomationPropertyPath.contractExpiryDate,
      ClaimAutomationPropertyPath.contractEffectiveDate,
      ClaimAutomationPropertyPath.contractSalePriceCAD,
    ],
    effectProperties: [ClaimAutomationPropertyPath.claimStatus, ClaimAutomationPropertyPath.claimJobStatus],
    allowMultipleRules: false,
    allowMultipleExpressions: true,
    isPropertySelectorDisabled: false,
    defaultExpression: {
      propertyPath: ClaimAutomationPropertyPath.totalAmount,
      type: ExpressionTypes.Equal,
      value: '',
    },
    defaultEffects: [
      createAssignEffect(ClaimAutomationPropertyPath.claimStatus),
      createAssignEffect(ClaimAutomationPropertyPath.claimJobStatus),
    ],
    properties: {
      [ClaimAutomationPropertyPath.totalAmount]: {
        propertyPath: ClaimAutomationPropertyPath.totalAmount,
        label: lang.claimTotalAmount,
        inputType: 'number',
        supportedExpressions: [...claimExpressionTypes],
      },
      [ClaimAutomationPropertyPath.contractExpiryDate]: {
        propertyPath: ClaimAutomationPropertyPath.contractExpiryDate,
        label: lang.expiryDate,
        inputType: 'dateTime',
        supportedExpressions: [...claimDateExpressionTypes],
      },
      [ClaimAutomationPropertyPath.contractEffectiveDate]: {
        propertyPath: ClaimAutomationPropertyPath.contractEffectiveDate,
        label: lang.effectiveDate,
        inputType: 'dateTime',
        supportedExpressions: [...claimDateExpressionTypes],
      },
      [ClaimAutomationPropertyPath.contractSalePriceCAD]: {
        propertyPath: ClaimAutomationPropertyPath.contractSalePriceCAD,
        label: lang.salePrice,
        inputType: 'number',
        supportedExpressions: [...claimExpressionTypes],
      },
    },
    effects: [
      {
        type: 'assign',
        propertyPath: ClaimAutomationPropertyPath.claimStatus,
        label: lang.claimStatus,
        options: claimStatuses,
      },
      {
        type: 'assign',
        propertyPath: ClaimAutomationPropertyPath.claimJobStatus,
        label: lang.claimJobStatus,
        options: claimJobStatuses,
      },
    ],
  };
}

export const createDealerClaimAutomationSchema = createClaimAutomationSchema;
export const createDealerGroupClaimAutomationSchema = createClaimAutomationSchema;
